import React from "react";
import { IneligibleScreen } from "../ResultScreens";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface NoReturnScreenProps {
  title: string;
  heading: string;
  body: string;
}

const NoReturnScreen: React.FC<NoReturnScreenProps> = props => {
  const { title, heading, body } = props;
  const { eligibleReturnDate } = useParams();

    const formattedEligibleReturnDate = eligibleReturnDate
        ? dayjs(eligibleReturnDate).utc().format("DD/MM/YYYY")
        : "";

  const bodyWithDate = body.replace("%RETURN_DATE%", formattedEligibleReturnDate);

  return <IneligibleScreen title={title} heading={heading} bodyText={bodyWithDate} hasContactUs={false} />;
};

export default NoReturnScreen;
